import { Row, Col } from 'reactstrap';

import icon1 from '../../assets/images/institute Dashboard Icons/income-w.png';
import icon2 from '../../assets/images/institute Dashboard Icons/expense-w.png';
import icon3 from '../../assets/images/institute Dashboard Icons/assets-w.png';
import icon4 from '../../assets/images/institute Dashboard Icons/staff-w.png';

const TopCards = ({instituteDetails,ovdCount,ovdPercentage,ovdPos},{id}) => {

  const ovdCountSum = ovdCount.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  const ovdPercentageSum = ovdPercentage.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  const overduePOS = ovdPos.reduce((accumulator, currentValue) => accumulator + currentValue, 0); 



  function formatNumberWithCommas(number) {
    return number.toLocaleString('en-IN'); 
  }

  const formatIndianAmount = (amount) => {
    if (amount >= 10000000) {
      return `${(amount / 10000000).toFixed(2)} Cr`;
    } else if (amount >= 100000) {
      return `${(amount / 100000).toFixed(2)} L`;
    } else {
      return formatNumberWithCommas(Math.round(amount));
    }
  }






  return (
    <>
    <Row className="g-3">
      {instituteDetails.length > 0 &&
        instituteDetails.map((item, index) => (
          <>
            {/* POS Card */}
            <Col sm="6" lg="3" key={`pos-${index}`}>
              <div
                style={{
                  backgroundColor: "#3e7bf0",
                  padding: "1rem",
                  borderRadius: "8px",
                  border: "1px solid #d4d6d5",
                  color: "#fff",
                  height: "100%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={icon1}
                    alt="icon"
                    style={{ marginRight: "10px", width: "35px", height: "35px" }}
                  />
                  <div>
                    <p style={{ margin: 0 }}>POS</p>
                    <h5 style={{ margin: 0 }}>
                      {item?.Active_POS
                        ? `₹${formatNumberWithCommas(Math.round(item?.Active_POS))}`
                        : "-"}
                    </h5>
                  </div>
                </div>
              </div>
            </Col>

            {/* Total Loans Card */}
            <Col sm="6" lg="3" key={`loans-${index}`}>
              <div
                style={{
                  backgroundColor: "#40d89f",
                  padding: "1rem",
                  borderRadius: "8px",
                  border: "1px solid #d4d6d5",
                  color: "#fff",
                  height: "100%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={icon2}
                    alt="icon"
                    style={{ marginRight: "10px", width: "35px", height: "35px" }}
                  />
                  <div>
                    <p style={{ margin: 0 }}>Total Loans</p>
                    <h5 style={{ margin: 0 }}>
                      {item?.loanidCount ? Math.round(item?.loanidCount) : "-"}
                    </h5>
                  </div>
                </div>
              </div>
            </Col>

            {/* POS / Ovd Amt. Card */}
            <Col sm="6" lg="3" key={`pos-ovd-${index}`}>
              <div
                style={{
                  backgroundColor: "#7857f0",
                  padding: "1rem",
                  borderRadius: "8px",
                  border: "1px solid #d4d6d5",
                  color: "#fff",
                  height: "100%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={icon3}
                    alt="icon"
                    style={{ marginRight: "10px", width: "35px", height: "35px" }}
                  />
                  <div>
                   <p style={{ margin: 0 }}>Ovd Amt. / POS</p>
                  <h5 style={{ margin: 0 }}>
                    {item?.overdueAmount
                      ? `₹${formatIndianAmount(Math.round(ovdPercentageSum))}`
                      : "-"}
                    {" / "}
                    {overduePOS
                      ? `₹${formatIndianAmount(Math.round(overduePOS))}`
                      : "-"}
                  </h5>
                  </div>
                </div>
              </div>
            </Col>

            {/* Total OvdCount Card */}
            <Col sm="6" lg="3" key={`ovd-count-${index}`}>
              <div
                style={{
                  backgroundColor: "#E7514C",
                  padding: "1rem",
                  borderRadius: "8px",
                  border: "1px solid #d4d6d5",
                  color: "#fff",
                  height: "100%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={icon4}
                    alt="icon"
                    style={{ marginRight: "10px", width: "35px", height: "35px" }}
                  />
                  <div>
                    <p style={{ margin: 0 }}>Total OvdCount</p>
                    <h5 style={{ margin: 0 }}>
                      {item?.overduecount ? Math.round(ovdCountSum) : "-"}
                    </h5>
                  </div>
                </div>
              </div>
            </Col>
          </>
        ))}
    </Row>
    </>
  
);
 
};

export default TopCards;
